import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../api/axios';
import { AdminPageHeader, AdminTableCard } from './AdminUi';
import './admin.css';

export default function AdminPrescriptions() {
  const [data, setData] = useState({ total: 0, results: [] });
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get('admin/prescriptions/', { params: { limit: 100 } })
      .then((r) => setData(r.data))
      .catch((e) => toast.error(e.response?.data?.error || 'Failed'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const openDetail = async (id) => {
    try {
      const r = await api.get(`admin/prescriptions/${id}/`);
      setSelected(r.data);
    } catch {
      toast.error('Could not load prescription');
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this prescription?')) return;
    await api.delete(`admin/prescriptions/${id}/`);
    toast.success('Deleted');
    setSelected(null);
    load();
  };

  return (
    <div>
      <AdminPageHeader title="Prescriptions" subtitle={`${data.total} total prescriptions`} />

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
      ) : (
        <AdminTableCard>
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th><th>User</th><th>Doctor</th><th>Meds</th><th>Date</th><th></th>
              </tr>
            </thead>
            <tbody>
              {data.results.map((p) => (
                <tr key={p.id}>
                  <td>{p.id}</td>
                  <td className="small">{p.user_email}</td>
                  <td>{p.doctor_name}</td>
                  <td>{p.medicines_count}</td>
                  <td className="small">{p.created_at ? new Date(p.created_at).toLocaleString() : '—'}</td>
                  <td className="text-nowrap">
                    <button className="btn btn-sm btn-outline-primary me-1 rounded-pill px-3" onClick={() => openDetail(p.id)}>View</button>
                    <button className="btn btn-sm btn-outline-danger rounded-pill px-3" onClick={() => remove(p.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </AdminTableCard>
      )}

      {selected && (
        <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.4)' }} onClick={() => setSelected(null)}>
          <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content border-0" style={{ borderRadius: 16 }}>
              <div className="modal-header">
                <h5 className="modal-title fw-bold">Prescription #{selected.id}</h5>
                <button type="button" className="btn-close" onClick={() => setSelected(null)} />
              </div>
              <div className="modal-body">
                <p><strong>User:</strong> {selected.user_email}</p>
                <p><strong>Doctor:</strong> {selected.doctor_name}</p>
                <p><strong>Advice:</strong> {selected.general_advice || '—'}</p>
                <pre className="bg-light p-3 rounded small">{JSON.stringify(selected.medicines, null, 2)}</pre>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
